const ExpCardData = [
  {
    company: "MyUse",
    project: "Fashion & Travel App",
    role: "React Native Developer",
    contract: "Part-time",
    duties: [
      "Digital Closet Management System",
      "Meteor API Integration",
      "React Native with Expo",
      "TanStack Query (React Query)",
      "Styled-components & NativeWind",
      "Expo Router Navigation",
      "React Native Reanimated",
      "AsyncStorage & Secure Store",
    ],
  },
  {
    company: "Fay Financial",
    project: "Applications Development",
    role: "ServiceNow Admin/Developer",
    contract: "Full-time",
    duties: [
      "ITSM Module",
      "Flow Designer automations",
      "Client/Server-side scripting",
      "Employee Center Portal",
      "ACLs & Roles",
      "Catalog Item Creation",
      "Integration hub with Spokes (Jira, Slack)",
    ],
  },
  {
    company: "SDH Immigration Services",
    project: "PollenLov",
    role: "React Native Developer",
    contract: "Part-time (ended)",
    duties: [
      "React Native Expo",
      "Expo router",
      "Firebase Auth and Validation",
      "Firestore",
      "Redux",
      "Javascript",
      "Node Modules",
    ],
  },
  {
    company: "Viseo",
    project: "My Unique Moments",
    role: "Junior Application Developer",
    contract: "Full-time (ended)",
    duties: [
      "Code refactoring",
      "Test flight deployment",
      "React Native CLI",
      "Push Notifications",
      "Scrum Methodology",
    ],
  },
];

export default ExpCardData;
